import { render, staticRenderFns } from "./BlockType23.vue?vue&type=template&id=b532bb9c&scoped=true&"
import script from "./BlockType23.vue?vue&type=script&lang=ts&"
export * from "./BlockType23.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType23.vue?vue&type=style&index=0&id=b532bb9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b532bb9c",
  null
  
)

export default component.exports